import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import {
  HandleError,
  HttpErrorHandler,
} from "../../../util/http-error-handler.service";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { Usuario } from "../../../models/usuario/usuario";
import { Produto } from "../../../models/produto/produto";
import { Cep } from "./models/cep.model";

const API_URL = environment.apiUrl;
const API_URL_BASE = environment.apiBaseUrl;

@Injectable({
  providedIn: "root",
})
export class MultiplasLojasService {
  private handleError: HandleError;

  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler) {
    this.handleError = httpErrorHandler.createHandleError(
      "ConfiguracaoCartaoService"
    );
  }
  listarCartoes(): Observable<any> {
    return this.http
      .get<any>(API_URL_BASE + "/fidel/cards/list")
      .pipe(catchError(this.handleError("listarCartoes", [])));
  }

  listarUsuarios(): Observable<any> {
    return this.http
      .get<any>(API_URL_BASE + "/fidel/scorecustomer/listUsersScoredNotPaged")
      .pipe(catchError(this.handleError("listarUsuarios", [])));
  }
  listarUsuariosPontuadosDodia(): Observable<any> {
    return this.http
      .get<any>(
        API_URL_BASE + "/fidel/scorecustomer/listUsersScoredDayNotPaged"
      )
      .pipe(catchError(this.handleError("listUsersScoredDayNotPaged", [])));
  }

  consultarUsuario(id, numero): Observable<any> {
    return this.http
      .get<any>(
        API_URL_BASE + `/fidel/scorecustomer/user?id=${id}&numero=${numero}`
      )
      .pipe(catchError(this.handleError("listarCartoes", [])));
  }

  cadastrarCartao(record: any): Observable<any> {
    return this.http
      .post<any>(API_URL_BASE + "v1/cards", record)
      .pipe(catchError(this.handleError("cadastrarCartao", record)));
  }
  atualizarCartao(record: any): Observable<any> {
    return this.http
      .put<any>(API_URL_BASE + "v1/cards", record)
      .pipe(catchError(this.handleError("atualizarCartao", record)));
  }
  inativarCartao(id: any): Observable<any> {
    return this.http
      .delete<any>(API_URL_BASE + `v1/cards/${id}`)
      .pipe(catchError(this.handleError("inativarCartao", id)));
  }

  editarCartao(id: any): Observable<any> {
    return this.http
      .get<any>(API_URL_BASE + `v1/cards/${id}`)
      .pipe(catchError(this.handleError("inativarCartao", id)));
  }

  pontuarCliente(record: any): Observable<any> {
    ///fidel/scorecustomer/registerpoint
    return this.http
      .post<Produto>(API_URL_BASE + "v1/scorecustomer/registerpoint", record)
      .pipe(catchError(this.handleError("pontuarCliente", record)));
  }

  cadastrarEPontuar(record: any): Observable<any> {
    ///fidel/scorecustomer/registerpoint
    return this.http
      .post<Produto>(
        API_URL_BASE + "v1/scorecustomer/registerUserAndRegisterPoint",
        record
      )
      .pipe(catchError(this.handleError("cadastrarEPontuar", record)));
  }

  marcarCartaoCompleto(record: any): Observable<any> {
    ///fidel/scorecustomer/registerpoint
    return this.http
      .post<Produto>(
        API_URL_BASE + "v1/scorecustomer/markCardForComplete",
        record
      )
      .pipe(catchError(this.handleError("marcarCartaoCompleto", record)));
  }

  /**************************** */

  obterTodos(
    param: any,
    direcao: string,
    propriedade: string
  ): Observable<any> {
    const params = new HttpParams()
      .set("Direcao", `${direcao}`)
      .set("descricao", `${param.descricao}`)
      .set("pageNumber", `${param.offset}`)
      .set("pageSize", `${param.limit}`);
    return this.http
      .get<any>(`${API_URL}/manage-stores`, { params })
      .pipe(catchError(this.handleError("obterTodos", [])));
  }

  cadastrarNovaEmpresa(record: any): Observable<any> {
    return this.http
      .post<any>(`${API_URL}/manage-stores`, record)
      .pipe(catchError(this.handleError("cadastrarCartao", record)));
  }

  editar(id: any): Observable<any> {
    return this.http
      .get<any>(`${API_URL}/manage-stores/${id}`)
      .pipe(catchError(this.handleError("detalhar", id)));
  }

  listSegments(descricao: string): Observable<any> {
    return this.http
      .get<any>(API_URL_BASE + "/v1/company/segments")
      .pipe(catchError(this.handleError("segment", [])));
  }

  searchAddress(cep: string): Observable<Cep> {
    return this.http.get<Cep>(`${API_URL_BASE}/v1/address/${cep}`);
  }

  reverseGeocode(addres: string): Observable<any> {
    const item = { address: addres };
    return this.http.post<any>(
      `${API_URL_BASE}/v1/address/reversegeocode`,
      item
    );
  }

  uploadLogo(id: any, file: any): Observable<any> {
    let headers = new HttpHeaders();
    //this is the important step. You need to set content type as null

   // headers.set("Accept", "multipart/form-data");
    headers.set("Content-Type", "multipart/form-data");
    const data: FormData = new FormData();
    data.append("file", file);
    data.append("id", id);
    return this.http.post<any>(`${API_URL}manage-stores/upload-logo`, data, {
      headers,
    });
  }
}
